/**
 * Imports
 *
 * Import any modules or components here.
 */
import { i18n, siteInfoLang } from "commonAssets/js/constants";
import { createElement } from "commonAssets/lib/createElement.js";
import { toTitleCase } from "commonAssets/lib/toTitleCase.js";

/**
 * Represents a contact form for the FAQ page.
 * @class
 * @property {Object} sitePages - The site pages object.
 * @property {string} domainSlug - The domain slug.
 * @property {string} domainFaqSlug - The domain FAQ slug.
 * @property {Object} importantDates - The important dates object.
 * @property {Object} faqPage - The FAQ page object.
 * @property {Object} faq - The FAQ object.
 */
export class FaqContactForm {
    constructor() {
        this.sitePages = siteInfoLang.Pages;
        this.domainSlug = window.location.hash.substring(1);
        this.domainFaqSlug = "faqs";
        this.importantDates = null;
        this.faqPage = this.sitePages.find(
            (page) => this.domainFaqSlug === page.PageName
        );
        this.faq = {};
    }

    init() {
        this.faqPage.PageContent.forEach(
            ({
                SectionTitle: title,
                SectionLead: lead,
                SectionFAQs: sectionFaqs,
            }) => {
                const titleString = title;

                const regex = /--[\w-]+/g;
                const matches = titleString.match(regex);

                const strippedMatches = matches
                    ? matches.map((match) => match.substring(2))
                    : null;

                if (
                    Boolean(strippedMatches) &&
                    !strippedMatches.includes(this.domainSlug)
                )
                    return;

                const titleSlice = titleString.search(matches);

                const Title = matches
                    ? titleString.slice(0, titleSlice)
                    : titleString;

                const sectionTitle = toTitleCase(Title);
                if (!this.faq.hasOwnProperty(sectionTitle)) {
                    this.faq[sectionTitle] = {};
                }
                sectionFaqs.forEach((faqItem) => {
                    this.faq[sectionTitle][faqItem.Question] = faqItem.Answer;
                });
            }
        );
    }

    makeFirstContactDropDown() {
        const faqCategories = Object.keys(this.faq);
        const firstContactDropDown = createElement(
            "div",
            { class: "form-group" },
            [
                // TODO: Must overwrite this method on sites using a chatbot with the code commented out below.
                // createElement("p", {
                //     class: "alert alert-info text-dark text-center fw-semibold",
                // }, [], i18n.getTranslation('chatbot')['for_fastest_response']),
                createElement(
                    "label",
                    { for: "contactCategory" },
                    [],
                    i18n.getTranslation("contact_us_category")
                ),
                createElement(
                    "select",
                    {
                        class: "form-select",
                        id: "contactCategory",
                        required: true,
                    },
                    [
                        createElement(
                            "option",
                            { value: "" },
                            [],
                            i18n.getTranslation("contact_us_select_a_reason")
                        ),
                        ...faqCategories.map((category) =>
                            createElement(
                                "option",
                                { value: category },
                                [],
                                category
                            )
                        ),
                    ]
                ),
            ]
        );
        return firstContactDropDown;
    }
}
